export * from './permission.actions';


// WEBPACK FOOTER //
// src/main/content/permission/store/actions/index.js